import React from "react";
import PropTypes from "prop-types";
import { buildFormButtonStylesheet } from "./ElementFormButtonStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementFormButton = (props) => {
  let element = props.element;
  let options = element.options;
  let important = props.builder !== true ? " !important" : "";
  const classes = style.classes(element, props.device);
  const stylesheet = buildFormButtonStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  return (
    <React.Fragment>
      <div className={classes.outer} data-element-id={element.id} data-font={element.options["button-font"]}>
        <button
          className={classes.inner + " cf-merge-tag-allowed"}
          data-element-id={element.id}
          dangerouslySetInnerHTML={{
            __html:
              props.builder == true
                ? "<div class='froala-editor'>" + element.html + "</div>"
                : element.html,
          }}
        ></button>
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:form-button`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  getWidthClass: (optionValue) => {
    if (!optionValue) return "cf-full-width";
    return optionValue === "custom" ? "" : optionValue;
  },

  classes: (element, device) => {
    const options = element.options;

    const widthOption = device === "mobile" && options["button-width-mobile"]
      ? options["button-width-mobile"]
      : options["button-width"];
    const buttonWidthClass = style.getWidthClass(widthOption);

    const formType = device === "mobile" && options["form-type-mobile"]
      ? options["form-type-mobile"]
      : options["form-type"];
    const isVerticalForm = !formType || formType === "vertical";

    const verticalAlignOption = device === "mobile" && options["form-vertical-button-alignment-mobile"]
      ? options["form-vertical-button-alignment-mobile"]
      : options["form-vertical-button-alignment"];
    const horizontalAlignClass = device === "mobile" && options["button-alignment-mobile"]
      ? options["button-alignment-mobile"]
      : options["button-alignment"] || "";
    const alignmentClass = isVerticalForm && verticalAlignOption
      ? `cf-outer-${verticalAlignOption}`
      : horizontalAlignClass;

    const outer = [
      "cf-button-outer",
      buttonWidthClass,
      alignmentClass,
      options["button-radius"] || "",
    ].filter(Boolean).join(" ");

    const inner = [
      "cf-button-inner cf-button cf-button-primary cf-text-element",
      buttonWidthClass,
      options["button-size"] || "cf-button-small",
    ].filter(Boolean).join(" ");

    return { outer, inner };
  },
};

export default ElementFormButton;
